import {
    ActivityRejectionReason,
    FacilityVisitDto,
    WorkoutReviewDto,
    ZonedDateTimeRangeDto
} from '../core/api/FitnessActivityClient';

export enum VerificationType {
    FACILITY_VISIT = 'facility-visit',
    WORKOUT = 'workout'
}

export interface VerificationItem {
    id: number;
    userId: string;
    verificationRequired: boolean;
    rejectionReason?: ActivityRejectionReason;
    zonedDateTimeRangeModel: ZonedDateTimeRangeDto;
    type: VerificationType;
}

export function facilityVisitToItem(dto: FacilityVisitDto): VerificationItem {
    return {
        id: dto.id,
        userId: dto.userId,
        verificationRequired: dto.verificationRequired,
        rejectionReason: dto.rejectionReason,
        zonedDateTimeRangeModel: dto.zonedDateTimeRangeModel,
        type: VerificationType.FACILITY_VISIT
    };
}

export function workoutToItem(dto: WorkoutReviewDto): VerificationItem {
    return {
        id: dto.id,
        userId: dto.userId,
        verificationRequired: dto.verificationRequired,
        rejectionReason: dto.rejectionReason,
        zonedDateTimeRangeModel: dto.zonedDateTimeRangeModel,
        type: VerificationType.WORKOUT
    };
}
